import { getProductList } from '../../data/productsUsed';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import { Grid } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import ProductIcon from '../../components/ProductIcon';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductUsageSection = ({
  products
}) => {
  const productList = getProductList();
  return /*#__PURE__*/_jsxs("section", {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "profilePage.AcademyProfile.productUsage.title"
      })
    }), /*#__PURE__*/_jsx(Grid, {
      children: products.map(thisProduct => {
        const product = productList.find(productBeingChecked => productBeingChecked.value === thisProduct);
        if (!product) {
          return null;
        }
        return /*#__PURE__*/_jsx(GridItem, {
          marginBlockStart: "600",
          size: 6,
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            flexDirection: "row",
            gap: "400",
            children: [/*#__PURE__*/_jsx(ProductIcon, {
              product: product.value
            }), product.text]
          })
        }, thisProduct);
      })
    })]
  });
};